module.exports = __webpack_public_path__ + "img/H2.ffda2e97.png";